<template>
    <div>
        <home-header page-name="応募" :istop="true"> </home-header>
        <home-list></home-list>
    </div>
</template>

<script>
    import HomeHeader from 'pages/commons/header/Header'
    import HomeList from './components/List'

    export default {
        mounted () {
            this.$store.dispatch('resetListObj')
        },
        components: {
            HomeHeader,
            HomeList,
        },
    }
</script>

<style></style>
